module.exports = __webpack_public_path__ + "media/images/pro/4-da4d4e93b412a280fa51a69ad332a754.png";